import { getSpacing } from '../../../const/spacing';
import { remToNumber, numberToRem } from '../../../helpers/rem';
import { textVariantStyleMap } from '../../Text/textConst';
export const LABEL_VARIANT = 'b3';
export const LABEL_SPACING_TOP = getSpacing('1/4');
const SPACE_BETWEEN_LABEL_AND_INPUT = getSpacing('1/4');
const labelLineHeight = textVariantStyleMap[LABEL_VARIANT].lineHeight;
const inputPaddingTop = remToNumber(SPACE_BETWEEN_LABEL_AND_INPUT) +
    remToNumber(labelLineHeight.toString()) +
    remToNumber(LABEL_SPACING_TOP);
export const inputPaddingTopInRem = numberToRem(inputPaddingTop);
